import { Component, effect, input } from '@angular/core';
import { BadgeComponent } from './badge.component';

interface RiskScoreDetail {
  id: number;
  tooltip: string;
  style: 'default' | 'green' | 'blue' | 'red' | 'yellow';
}

@Component({
  selector: 'dxc-risk-score-badge',
  imports: [BadgeComponent],
  template: `
    @if (riskDetail) {
      <dxc-badge
        additionalClasses="min-w-9"
        [style]="riskDetail.style || 'default'"
        [text]="riskDetail.tooltip.charAt(0) || ''"
        [tooltip]="riskDetail.tooltip || ''"
      />
    }
  `
})
export class RiskScoreBadgeComponent {
  riskScore = input.required<number | string>();
  riskScoreDetail: RiskScoreDetail[] = [
    { id: 1, tooltip: 'No Match', style: 'green' },
    { id: 3, tooltip: 'Potential Match', style: 'yellow' },
    { id: 5, tooltip: 'Exact Match', style: 'red' }
  ];
  riskDetail: RiskScoreDetail | undefined;

  constructor() {
    effect(() => {
      const scoreAsNumber = Number(this.riskScore());
      this.riskDetail = this.riskScoreDetail.find(
        (detail) => detail.id === scoreAsNumber
      );
    });
  }
}
